import React from 'react';
import DataMatrixBarcode from './DataMatrixBarcode';

const modalWrapperStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};

const modalContainerStyle = {
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  maxWidth: '600px',
  width: '90%',
  maxHeight: '80vh',
  overflowY: 'auto',
};

const codesGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: '10px',
  marginBottom: '20px',
};

const codeItemStyle = {
  textAlign: 'center',
};

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const ScannedCodesModal = ({ codes, onClose }) => {
  return (
    <div style={modalWrapperStyle} onClick={onClose}>
      <div style={modalContainerStyle} onClick={(e) => e.stopPropagation()}>
        <h3>Сканированные коды</h3>
        <div style={codesGridStyle}>
          {codes.map((code, index) => (
            <div key={index} style={codeItemStyle}>
              <DataMatrixBarcode value={code} size={100} />
            </div>
          ))}
        </div>
        <button style={buttonStyle} onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>
  );
};

export default ScannedCodesModal;
